var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page",attrs:{"id":"services"}},[_c('div',{staticClass:"wrapper wordpressContent",domProps:{"innerHTML":_vm._s(_vm.about.content.rendered)}})])}
var staticRenderFns = []

export { render, staticRenderFns }